<script>
export default {
  name: "CrmNewsCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    dataTest: {
      type: String,
      default: "news-card"
    },
    dateFormat: {
      type: String,
      default: "DD MMM YYYY"
    }
  },
  emits: ["select"],
  computed: {
    title() {
      return this.item.news_language?.[0]?.name || this.item.name || "-";
    },
    description() {
      return (
        this.item.news_language?.[0]?.short_description ||
        this.item.short_description ||
        ""
      );
    },
    createdDate() {
      if (!this.item.created_date) return "-";
      return this.$moment(this.item.created_date).format(this.dateFormat);
    },
    imageSrc() {
      return this.item.image_url || this.handleImageSrc;
    }
  },
  methods: {
    selectCard() {
      this.$emit("select", this.item);
    }
  }
};
</script>

<template>
  <button
    type="button"
    class="crm-news-card"
    :data-test="dataTest"
    @click="selectCard"
  >
    <c-img-lazy :src="imageSrc" class="crm-news-card__image" />
    <span class="crm-news-card__content">
      <strong>{{ title }}</strong>
      <small>{{ description }}</small>
      <div class="crm-news-card__date">
        <span>{{ $t("create_date") }}</span>
        <span>{{ createdDate }}</span>
      </div>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.crm-news-card {
  display: grid;
  width: 100%;
  height: 106px;
  grid-template-columns: 33% minmax(0, 1fr);
  overflow: hidden;
  margin-bottom: 12px;
  border: 0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: left;
}

.crm-news-card__image {
  width: 100%;
  height: auto;
  max-height: 106px;
}

.crm-news-card__image :deep(.v-img) {
  height: 100%;
}

.crm-news-card__content {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 9px 10px;
}

.crm-news-card__content strong,
.crm-news-card__content small {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.crm-news-card__content strong {
  font-size: var(--text-lg);
  line-height: 1.25;
  -webkit-line-clamp: 2;
}

.crm-news-card__content small {
  color: #9a9a9a;
  font-size: var(--text-md);
  line-height: 1.35;
  -webkit-line-clamp: 2;
}

.crm-news-card__date {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  color: #a0a0a0;
  font-size: var(--text-md);
  font-weight: 800;
}
</style>
